module.exports = __webpack_public_path__ + "static/img/1.1316f74.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/sp/1.png
// module id = 0bjZ
// module chunks = 0